var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.045,
    height: 40.996,
    viewBox: "0 0 40.045 40.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#030104;stroke:#f7f7f7;stroke-width:.8px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_3_",
    "data-name": "icon (3)",
    transform: "translate(.18 .4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_83",
    d: "M0 0h17.853v2.894H0z",
    className: "cls-1",
    "data-name": "Rectangle 83",
    transform: "translate(5.406 8.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M21.338 19.165a6.29 6.29 0 1 0-2.388 2.393l7.076 7.076 2.388-2.391zm-2.838-.449a3.853 3.853 0 0 1-5.31 0 3.757 3.757 0 1 1 5.31 0z",
    className: "cls-1",
    "data-name": "Path 38",
    transform: "translate(10.666 11.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M28.665 35.359H3.772a.714.714 0 0 1-.714-.712V3.553a.713.713 0 0 1 .714-.714h24.893a.711.711 0 0 1 .712.714v15.862a7.441 7.441 0 0 1 2.842 1.3V3.553A3.556 3.556 0 0 0 28.665 0H3.772A3.558 3.558 0 0 0 .219 3.553v31.095A3.557 3.557 0 0 0 3.772 38.2h24.893c1.486 0 2.189-.351 2.718-1.649l-1.289-1.289a3.74 3.74 0 0 1-1.429.097z",
    className: "cls-1",
    "data-name": "Path 39",
    transform: "translate(-.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_84",
    d: "M0 0h17.853v2.894H0z",
    className: "cls-1",
    "data-name": "Rectangle 84",
    transform: "translate(5.406 16.96)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnical);
export default __webpack_public_path__ + "static/media/technical.5116249f.svg";
export { ForwardRef as ReactComponent };